run.$inject = ['$rootScope', '$templateCache', '$state', '$stateParams', '$timeout', 'MenuConstant', 'perfil']

export default function run ($rootScope, $templateCache, $state, $stateParams, $timeout, MenuConstant, perfil) {
	$templateCache.put('updatePersonalData.html', require('./Actualizacion_Perfil/updatePersonalData.html'));
	$templateCache.put('updateGenericTemplate.html', require('./Actualizacion_Perfil/updateGenericTemplate.html'));
	MenuConstant[0]['menu'].push(perfil)
}



// WEBPACK FOOTER //
// ./src/app/u-faculty/profile/perfil/perfil.run.js